import { render, staticRenderFns } from "./DialogModelsAdd.vue?vue&type=template&id=a08b19fe"
import script from "./DialogModelsAdd.vue?vue&type=script&lang=js"
export * from "./DialogModelsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports